import { HttpError } from '@littlebird/sdk';

export function getArchiveErrorDescription(
  error: unknown,
  action: 'archive' | 'unarchive' | 'delete'
) {
  if (error instanceof HttpError) {
    if (error.status === 400 && error.message) return error.message;
    if (error.status >= 500) {
      return `The server could not ${action} this chat. Please try again.`;
    }
  }

  if (
    error instanceof Error &&
    error.message === 'Archived state was not confirmed by the server'
  ) {
    return 'This server does not support chat archiving yet. Please update and try again.';
  }

  return `Check your connection, then try to ${action} this chat again.`;
}
